import React from 'react';

import { formatDate } from "utils";

import { BackendJob } from "components/EditJob";
import { JobStatus } from "components/JobBoard";

import {
    JobContainer,
    TitlesContainer,
    Title,
    Subtitle,
    NewCandidatesInfo,
    PersonOutlineIconStyled,
    JobInfoContainer,
    JobInfoItem,
    CalendarTodayOutlinedIconStyled,
    StartingDate,
    PersonOutlineIconInColorStyled,
    HourglassEmptyOutlinedIconStyled,
    PendingJobInfo,
    CandidateInfo,
    LocationOnOutlinedIconStyled,
    Badge
} from './JobList.styles'

interface JobListItemProps {
    job: BackendJob,
    onJobClick: (job: BackendJob) => void,
    isActive?: boolean
}

const JobListItem = ({ job, onJobClick, isActive }: JobListItemProps) => {
    const {
        title,
        id,
        location_address,
        newCandidates,
        startDate,
        total_applications = 0,
        status
    } = job;

    const PendingBadge = (
        <PendingJobInfo>
            <HourglassEmptyOutlinedIconStyled />
            <span>In Review</span>
        </PendingJobInfo>
    );

    const NewCandidatesBadge = newCandidates ? (
        <NewCandidatesInfo>
            <PersonOutlineIconStyled />
            <span>{newCandidates} New</span>
        </NewCandidatesInfo>
    ) : null;

    return (
        <JobContainer
            key={id}
            onClick={() => onJobClick(job)}
            className='no-fastclick'
            $isActive={isActive}
        >
            <TitlesContainer>
                <div>
                    <Title>{title}</Title>
                </div>
                {status === JobStatus.posted ? PendingBadge : NewCandidatesBadge}
            </TitlesContainer>
            <JobInfoContainer>
            <JobInfoItem>
                    <LocationOnOutlinedIconStyled />
                    <Subtitle> {location_address}</Subtitle>
                </JobInfoItem>
                <JobInfoItem>
                    <CalendarTodayOutlinedIconStyled />
                    <StartingDate>Starting: {formatDate(startDate as string)}</StartingDate>
                </JobInfoItem>
                <JobInfoItem>
                    <PersonOutlineIconInColorStyled />
                    <CandidateInfo>{total_applications} {total_applications <= 1 ? 'Candidate' : 'Candidates'}</CandidateInfo>
                </JobInfoItem>
            </JobInfoContainer>
        </JobContainer>
    )
}

export default JobListItem;
